export const baseImageUrl = import.meta.env.VITE_URL_FILES;

export const imageUrl = (file?: string) => {
	if (!file) return undefined;

	return baseImageUrl + '/' + file;
};
